import http from './http';

export default {
  // 获取大题列表
  getByPaperId(paperId) {
    return http.get('/o1/section_controller/index', { paper_id: paperId });
  },

  // 获取大题详情
  getDetail(id) {
    return http.get('/o1/section_controller/read', { id });
  },

  // 创建大题
  create(data) {
    return http.post('/o1/section_controller/save', data);
  },

  // 更新大题
  update(id, data) {
    return http.post('/o1/section_controller/update', { id, ...data });
  },

  // 删除大题
  delete(id) {
    return http.post('/o1/section_controller/delete', { id });
  },

  // 更新排序
  updateSort(paperId, sortData) {
    return http.post('/o1/section_controller/updateSort', { 
      paper_id: paperId, 
      sort_data: sortData 
    });
  }
};
